export default "__VITE_ASSET__CtAV4V7Z__"